import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import ExportWidgetActionDelegate from "views/components/widgets/ExportWidgetAction/ExportWidgetActionDelegate";
import EventsWidget from "views/logic/widgets/events/EventsWidget";
const ExportWidgetAction = {
  type: "export-widget-action",
  position: "menu",
  isHidden: (w) => ![AggregationWidget.type, EventsWidget.type].includes(w.type),
  component: ExportWidgetActionDelegate
};
export default ExportWidgetAction;
